import { sidebarActionTypes } from './Constants';

export function getUseDataRequest(
	navigateFromPackagesPage = false,
	navigateFromSignUpPage = false,
) {
	return {
		type: sidebarActionTypes.GET_USER_DATA_REQUEST,
		payload: {
			navigateFromPackagesPage,
			navigateFromSignUpPage,
		},
	};
}

export function getUseDataSuccess(userData) {
	return {
		type: sidebarActionTypes.GET_USER_DATA_SUCCESS,
		payload: {
			userData,
		},
	};
}

export function getUseDataError(error) {
	return {
		type: sidebarActionTypes.GET_USER_DATA_ERROR,
		error: true,
		payload: {
			error,
		},
	};
}

export function setExpandedMenu(status) {
	return {
		type: sidebarActionTypes.SET_EXPANDED_MENU,
		error: true,
		payload: {
			status,
		},
	};
}

export function logout(route, shouldDeleteActivationCode = true) {
	return {
		type: sidebarActionTypes.LOGOUT,
		payload: {
			route,
			shouldDeleteActivationCode,
		},
	};
}

export function clearUserData() {
	return {
		type: sidebarActionTypes.CLEAR_USER_DATA,
	};
}

export function setNotificationCount(count) {
	return {
		type: sidebarActionTypes.SET_NOTIFICATION_COUNT,
		payload: {
			count,
		},
	};
}

export function getCountriesRequest() {
	return {
		type: sidebarActionTypes.GET_COUNTRIES_REQUEST,
	};
}

export function getCountriesSuccess(countries) {
	return {
		type: sidebarActionTypes.GET_COUNTRIES_SUCCESS,
		payload: {
			countries,
		},
	};
}

export function getCountriesError() {
	return {
		type: sidebarActionTypes.GET_COUNTRIES_ERROR,
	};
}

export function setCountryOptionCode(selectedCountryCode) {
	return {
		type: sidebarActionTypes.SET_COUNTRY_OPTION_CODE,
		payload: {
			selectedCountryCode,
		},
	};
}

export function setCountryOption(countryCode) {
	return {
		type: sidebarActionTypes.SET_COUNTRY_OPTION,
		payload: {
			countryCode,
		},
	};
}

export function updateUserDataLocale(locale) {
	return {
		type: sidebarActionTypes.UPDATE_USER_LOCALE,
		payload: {
			locale,
		},
	};
}

export function updateUserDataTheme(theme) {
	return {
		type: sidebarActionTypes.UPDATE_USER_THEME,
		payload: {
			theme,
		},
	};
}

export function setCountry(country) {
	return {
		type: sidebarActionTypes.SET_COUNTRY,
		payload: {
			country,
		},
	};
}

export function getMadeListsRequest() {
	return {
		type: sidebarActionTypes.GET_MENU_MADE_LISTS_REQUEST,
	};
}

export function getMadeListsSuccess(data) {
	return {
		type: sidebarActionTypes.GET_MENU_MADE_LISTS_SUCCESS,
		payload: {
			data,
		},
	};
}

export function getMadeListsError() {
	return {
		type: sidebarActionTypes.GET_MENU_MADE_LISTS_ERROR,
	};
}
